<template>
  <div class="st-spinner" aria-live="assertive" :aria-atomic="true">
    <component class="st-spinner__loader" :is="spinnerVariation" />
    <span ref="spinnerMessage" :class="messageClassList"></span>
  </div>
</template>

<script>
import SmallSpinner from "./SmallSpinner.vue";
import LargeSpinner from "./LargeSpinner.vue";
import { computed, onMounted, ref } from "vue";
export default {
  name: "st-spinner",
  props: {
    loadingMessage: {
      type: String,
      default: "Laddar...",
      required: true,
    },
    small: {
      type: Boolean,
    },
    hideLoadingMessage: {
      type: Boolean,
    },
    font: {
      type: String,
      validator(font) {
        return ["primary", "secondary"].includes(font);
      },
      default: "primary",
    },
  },
  setup(props) {
    const spinnerMessage = ref(null);
    onMounted(() => {
      setTimeout(() => {
        if (spinnerMessage.value) {
          spinnerMessage.value.innerHTML = props.loadingMessage;
        }
      }, 100);
    });

    const messageClassList = computed(() => {
      const message = "st-spinner__message";
      return [
        message,
        props.hideLoadingMessage && `${message}--sr-only`,
        props.font && `${message}--font-${props.font}`,
        props.small && `${message}--small`,
      ];
    });

    const spinnerVariation = computed(() => {
      return props.small ? SmallSpinner : LargeSpinner;
    });

    return {
      messageClassList,
      spinnerVariation,
      spinnerMessage,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__loader {
    animation: rotate 1s linear infinite;
  }

  @keyframes rotate {
    from {
      transform: rotateZ(0);
    }
    to {
      transform: rotateZ(360deg);
    }
  }

  &__message {
    margin-top: rem-calc(16);
    font-size: rem-calc(24);
    color: var(--text-color-primary);
    line-height: rem-calc(32);

    &--font-primary {
      font-family: var(--font-primary);
      font-weight: var(--font-weight-regular);
    }

    &--font-secondary {
      font-family: var(--font-secondary);
      font-weight: var(--font-weight-bold);
    }

    &--small {
      font-size: rem-calc(16);
    }

    &--sr-only {
      @include sr-only();
    }
  }
}
</style>
